export default __webpack_public_path__ + "static/media/BC.eea6148a.svg";